import React, { useState, useEffect } from "react";
import api from "../../api/axios"; // ✅ Axios centralisé
import { Grid, Button } from "@mui/material";
import MDBox from "components/MDBox";
import DataTable from "examples/Tables/DataTable";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

const Pledges = () => {
  const [pledges, setPledges] = useState([]);
  const [loading, setLoading] = useState(false);

  // Helper function to calculate days until due date
  const calculateDueDays = (dueDate) => {
    const today = new Date();
    const due = new Date(dueDate);
    const diffTime = due - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays > 0 ? `Due in ${diffDays} days` : "Past Due";
  };

  useEffect(() => {
    const fetchPledges = async () => {
      setLoading(true);
      try {
        const response = await api.get("/quickbooks/pledges/");
        const pledgeRows = response.data.pledges.QueryResponse.Invoice.map((pledge) => ({
          date: pledge.TxnDate,
          number: pledge.DocNumber,
          customer: pledge.CustomerRef?.name || "N/A",
          amount: pledge.TotalAmt.toFixed(2),
          status: pledge.Balance === 0 ? "Closed" : calculateDueDays(pledge.DueDate),
          actions: "View / Edit", // Remplace par composants d'action si nécessaire
        }));
        setPledges(pledgeRows);
      } catch (err) {
        console.error("Failed to fetch pledges:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchPledges();
  }, []);

  const columns = [
    { Header: "Date", accessor: "date", align: "left" },
    { Header: "No.", accessor: "number", align: "left" },
    { Header: "Customer", accessor: "customer", align: "left" },
    { Header: "Amount", accessor: "amount", align: "right" },
    { Header: "Status", accessor: "status", align: "center" },
    { Header: "Action", accessor: "actions", align: "center" },
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container justifyContent="flex-end">
          <Button variant="contained" color="primary">
            Add Pledge
          </Button>
        </Grid>
        <MDBox pt={3}>
          <DataTable table={{ columns, rows: pledges }} isLoading={loading} noEndBorder />
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
};

export default Pledges;
